// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  templateId: __t.string(),
  displayName: __t.string(),
  meleeWeapon: __t.string(),
  shield: __t.string(),
  armor: __t.string(),
  rangedWeapon: __t.string(),
  mount: __t.string(),
  weaponTrainingRank: __t.u32(),
  shieldTrainingRank: __t.u32(),
  formationTrainingRank: __t.u32(),
  enduranceTrainingRank: __t.u32(),
  skirmishingTrainingRank: __t.u32(),
  horsemanshipTrainingRank: __t.u32(),
  fieldcraftTrainingRank: __t.u32(),
};
